import { jwtDecode } from 'jwt-decode';

export const isTokenValid = (token) => {
  if (!token) return false;
  
  try {
    // Decode the token
    const decoded = jwtDecode(token);
    
    // Check if token has expiration
    if (!decoded.exp) return false;
    
    // Get current time in seconds
    const currentTime = Date.now() / 1000;
    
    // Check if token is expired
    if (decoded.exp < currentTime) return false;
    
    // Token is valid
    return true;
  } catch (error) {
    // Invalid token format
    return false;
  }
};

export const getTokenExpiry = (token) => {
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    return decoded.exp ? new Date(decoded.exp * 1000) : null;
  } catch {
    return null;
  }
};